import { loadLevel, type LevelDef } from '../../levelSchema';
import tinyLawn from './01-tiny-lawn.json';
import backPatch from './02-back-patch.json';
import steppingStones from './03-stepping-stones.json';
import gardenRocks from './04-garden-rocks.json';
import hedgeRows from './05-hedge-rows.json';
import pullBackPockets from './06-pull-back-pockets.json';
import tractorTrial from './07-tractor-trial.json';
import gardenParty from './08-garden-party.json';
import squirrelPatch from './09-squirrel-patch.json';

/** Hand-built prototype levels, in play order. Validated at load. */
export const PROTO_LEVELS: readonly LevelDef[] = [
  tinyLawn,
  backPatch,
  steppingStones,
  gardenRocks,
  hedgeRows,
  pullBackPockets,
  tractorTrial,
  gardenParty,
  squirrelPatch,
].map(loadLevel);
